import { render, staticRenderFns } from "./LazyImageWrapper.vue?vue&type=template&id=d49d8bfa&"
import script from "./LazyImageWrapper.vue?vue&type=script&lang=ts&"
export * from "./LazyImageWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports